import { Button } from "@/components/ui/button";
import { UserAuthForm } from "@/components/auth/user-auth-form";
import React from "react";
import commonForgeLogo from "../assets/logo.svg";
import { SimpleLink } from "@/components/ui/simple-link";

export default function SignInView() {
  const [mode, setMode] = React.useState("login");

  return (
    <>
      <div className="container relative grid h-[800px] min-h-screen flex-col items-center lg:max-w-none lg:grid-cols-2 lg:px-0">
        {mode !== "login" && (
          <Button
            // href="/examples/authentication"
            className="absolute left-4 top-4 md:left-8 md:top-8"
            variant="ghost"
            onClick={() => setMode("login")}
          >
            Login
          </Button>
        )}
        <div className="lg:p-8">
          {mode === "login" && (
            <div className="mx-auto flex w-full max-w-[500px] flex-col justify-center space-y-6 lg:w-[450px]">
              <div className="flex flex-col space-y-2">
                <h1 className="text-4xl font-light tracking-tight">
                  Welcome back!
                </h1>
                <p className="text-sm text-muted-foreground">
                  Enter your credentials to access your account
                </p>
              </div>
              <UserAuthForm />
              <div className="text-sm">
                Don't have an account?{" "}
                <SimpleLink href="https://www.commonforge.com/contact">
                  Contact us!
                </SimpleLink>
              </div>
            </div>
          )}
        </div>
        <div className="relative hidden h-full flex-col p-10 dark:border-r lg:flex">
          <div className="absolute inset-0 bg-[url('/wind-power-plant-solar-pannels-low-angle.jpg')] bg-cover bg-center" />
          <div className="relative z-20 flex max-w-[610px] flex-col items-start">
            <img src={commonForgeLogo} className="mb-8 sm:w-[400px] xl:w-fit" />
            <div className="mb-4 text-2xl font-bold leading-snug [text-wrap:balance] xl:text-4xl xl:leading-snug">
              AI-Powered Project Review Automation
            </div>
            <Button asChild={true} variant={"outlineAlt"} className="">
              <a href="https://commonforge.com">Learn more...</a>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
